<template>
    <div class="dashboard-container">
      <t-form
        :onSubmit="submitserviceCenterAddress"
        id="service_center_address_form"
        :schema="serviceCenterAddressScema"
      >
        <div class="dashboard-row">
            <div class="input-title"><span>{{$translation($websiteText().my_profile_contact_email)}}</span></div>
            <div class="input-content" playwright-id="shipping-email">
            <t-input-text
                rootStyle="width:inherit"
                v-model="serviceCenterAddress.email"
                :modelValue="serviceCenterAddress.email?serviceCenterAddress.email:customer.email"
                placeholder="example@email.com"
                name="email"
                :disabled = 'disabled'
            ></t-input-text>
            </div>
        </div>  

        <div class="dashboard-row">
          <div class="input-title"><span>{{$translation($websiteText().my_profile_phone_number)}}</span></div>
          <div class="input-content">
            <div style = "width:45%" playwright-id='shipping-phone-dial'>
              <t-input-select
                style="margin-right: 5px; "
                :options="$store.getters.phoneCodes"
                :filter="true"
                optionValue="dial_code"
                optionLabel="dial_code"
                v-model="serviceCenterAddress.phone_dial"
                :displayError="true"
                optionLabel1="name"
                filterLabel="name"
                name="phone_dial"
                placeholder="+123"
                :disabled = 'disabled'
                :filterFields="['dial_code', 'name']"
              ></t-input-select>
            </div>
            <div style="width:45%" playwright-id='shipping-phone-number'>
              <t-input-text
                
                v-model="serviceCenterAddress.phone_number"
                name="phone_number"
                :displayError="false"
                placeholder="01 23 45 67 89"
                :disabled = 'disabled'
              ></t-input-text>
            </div>
            
          </div>
        </div>
        
        <div class="dashboard-row">
          <div class="input-title"><span>{{$translation($websiteText().my_profile_address)}}</span></div>
          <div class="input-content" playwright-id='shipping-address'>
            <t-input-text
              rootStyle="width:inherit"
              id="locationTextField1"
              v-model="serviceCenterAddress.address"
              :placeholder="$translation($websiteText().my_profile_address_placeholder)"
              name="address"
              style="width: 100%"
              :disabled = 'disabled'
              @input="init()"
              :autocomplete="'off'"
              :ariaAutocomplete="'none'"
            ></t-input-text>
          </div>
        </div>
  
        <div class="dashboard-row">
          <div class="input-title"><span>{{$translation($websiteText().my_profile_company)}}</span></div>
          <div class="input-content" playwright-id='shipping-company'>
            <t-input-text
              rootStyle="width:inherit"
              v-model="serviceCenterAddress.name"
              :placeholder="$translation($websiteText().my_profile_company)"
              name="name"
              :disabled = 'disabled'
            ></t-input-text>
          </div>
        </div>
  
        <div class="dashboard-row">
          <div class="input-title"><span>{{$translation($websiteText().my_profile_street)}}</span></div>
          <div class="input-content" playwright-id='billing-street'>
            <t-input-text
              rootStyle="width:inherit"
              v-model="serviceCenterAddress.street_name"
              name="street_name"
              :placeholder="$translation($websiteText().my_profile_street)"
              :disabled = 'disabled'
            ></t-input-text>
          </div>
        </div>
  
        <div class="dashboard-row">
          <div class="input-title"><span>{{$translation($websiteText().my_profile_zip)}}</span></div>
          <div class="input-content" playwright-id='shipping-zip-code'>
            <t-input-text
              rootStyle="width:inherit"
              v-model="serviceCenterAddress.zip"
              name="zip"
              :placeholder="$translation($websiteText().my_profile_zip)"
              :disabled = 'disabled'
            ></t-input-text>
          </div>
        </div>
        <div class="dashboard-row">
          <div class="input-title"><span>{{$translation($websiteText().my_profile_city)}}</span></div>
          <div class="input-content" playwright-id='shipping-city'>
            <t-input-text
              rootStyle="width:inherit"
              v-model="serviceCenterAddress.city"
              name="city"
              :placeholder="$translation($websiteText().my_profile_city)"
              :disabled = 'true'
            ></t-input-text>
          </div>
        </div>
        <div class="dashboard-row">
          <div class="input-title"><span>{{$translation($websiteText().my_profile_state)}}</span></div>
          <div class="input-content" playwright-id='shipping-state'>
            <t-input-text
              rootStyle="width:inherit"
              v-model="serviceCenterAddress.state"
              name="state"
              :placeholder="$translation($websiteText().my_profile_state)"
              :disabled = 'true'
            ></t-input-text>
          </div>
        </div>
        <div class="dashboard-row">
          <div class="input-title"><span>{{$translation($websiteText().my_profile_country)}}</span></div>
          <div class="input-content" playwright-id='shipping-country'>
            <t-input-text
              rootStyle="width:inherit"
              v-model="serviceCenterAddress.country"
              name="country"
              :placeholder="$translation($websiteText().my_profile_country)"
              :disabled='true'
            ></t-input-text>
          </div>
        </div>
        



        <div class="dashboard-row">
            <div class="input-title"><span>{{$translation("Categories")}}</span></div>
            <div class="input-content" playwright-id='shipping-country'>
                <TMultiSelectCategory
                v-model="serviceCenterAddress.categories"
                :categories="categoryTreeOptions"
                :placeholder="$translation($websiteText().post_request_category_placeholder)"
                type="multiselect"
                :emmit_at_watch="false"
            />
          </div>
        </div>

        <div class="dashboard-row">
            <div class="input-title"><span>{{$translation("Brands")}}</span></div>
            <div class="input-content" playwright-id='shipping-country'>
                <TMultiSelectCategory
                v-model="serviceCenterAddress.brands"
                :categories="brandsOptions"
                :placeholder="$translation($websiteText().post_request_category_placeholder)"
                type="multiselect"
                :emmit_at_watch="false"/>
          </div>
        </div>


        <div class="dashboard-row">
            <div class="input-title"><span>{{$translation("Certificate")}}</span></div>
            <div class="input-content" playwright-id='shipping-country'>
                <input type="file" @change="handleFileChange" accept="application/pdf" />
                <a v-if="blobUrl" :href="blobUrl" target='_blank'>Link</a>
          </div>
        </div>

        
        <div class="dashboard-row" v-if="showSubmit" playwright-id='shipping-save-button'>
          <t-button
            style="margin-left: auto"
            :label="$translation($websiteText().website_generals_save_btn)"
            formSubmit="service_center_address_form"
            type="submit"
            :onClick="submitShippingValidate"
            :color="'primary-color'"
          />
        </div>
      </t-form>
    </div>
  </template>
  
  <script>
  import store from "../../../../store";
  import * as Yup from "yup";
  import { reactive } from "@vue/reactivity";
  import TInputText from "../../../../common/components/input-text/TInputText.vue";
  import TTextarea from "../../../../common/components/input-text/TTextarea.vue";
  import TInputSelect from "../../../../common/components/input-text/TInputSelect.vue";
  import TForm from "../../../../common/components/TForm.vue";
  import TButton from "../../../../common/components/buttons/TButton.vue";
  import TMultiSelectCategory from "../../../../common/components/controls/TMultiSelectCategory.vue";

  import CategoryService from '../../../../common/services/catalog/CategoryService';
  import BrandService from '../../../../common/services/catalog/BrandService';

  import GooglePlacesHelper from "../../../../common/helpers/GooglePlacesHelper";
  import { SHOW_TOAST_MESSAGE } from "../../../../common/store/actions";
  import GeneralHelper from "../../../../common/helpers/GeneralHelper";
  import phoneCodes from "../../../../common/store/phoneCodes";

  import {
    CREATE_SERVICE_CENTER,
    EDIT_SERVICE_CENTER,
    GET_SERVICE_CENTER,
    } from "../../store/customer/actions";

    
  export default {
    components: { TInputText, 
        TInputSelect, 
        TForm, 
        TButton, 
        TMultiSelectCategory
        // TTextarea 
    },
  
    mounted() {
        this.getCategories();
        this.getBrands();
        this.getServiceCenter()
    },
    data(){
        return {
            categoryTreeOptions:[],
            brandsOptions:[],
            maxSize: 5 * 1024 * 1024, // 5MB limit
        }
    },
    methods:{

        async getServiceCenter(){
          this.$store.dispatch(GET_SERVICE_CENTER)
        },

        async getCategories(){
                let categoryService = new CategoryService();
                var data = await categoryService.getTree();
                this.categoryTreeOptions = data.data.data
        },

        async getBrands(){
            var brandService = new BrandService()
            var data = await brandService.getSpecBrands();
            this.brandsOptions = data.data.data
        },

        handleFileChange(event) {
            const file = event.target.files[0];

            if (!file) return;
            if (file.size > this.maxSize) {
                this.error = "File size exceeds the 5MB limit.";
                this.pdfBlobUrl = null
                this.serviceCenterAddress.certificate = null;
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                this.serviceCenterAddress.certificate = e.target.result;
                console.log(this.serviceCenterAddress.certificate)
                this.error = null;
            };

            reader.readAsDataURL(file);
        },

        removeDialCode(phone_dial, phone_number) {
            if (phone_number.startsWith(phone_dial)) {
                return phone_number.substring(phone_dial.length);
            }
            return phone_number;
        }
        
    },

    watch:{
      '$store.getters.serviceCenterAddress': function (){
        let serviceCenterGetter = this.$store.getters.serviceCenterAddress

        this.serviceCenterAddress.id = serviceCenterGetter.id
        this.serviceCenterAddress.email = this.customer.email
        this.serviceCenterAddress.phone_dial = serviceCenterGetter.phone_dial
        this.serviceCenterAddress.phone_number = this.removeDialCode(serviceCenterGetter.phone_dial, serviceCenterGetter.phone_number)
        this.serviceCenterAddress.city = serviceCenterGetter.city
        this.serviceCenterAddress.country = serviceCenterGetter.country
        this.serviceCenterAddress.state = serviceCenterGetter.state
        this.serviceCenterAddress.zip = serviceCenterGetter.zip
        this.serviceCenterAddress.street_name = serviceCenterGetter.street_name
        this.serviceCenterAddress.name = serviceCenterGetter.name
        this.serviceCenterAddress.address = serviceCenterGetter.address
        this.serviceCenterAddress.certificate = serviceCenterGetter.certificate
        this.serviceCenterAddress.brands = serviceCenterGetter.brands
        this.serviceCenterAddress.categories = serviceCenterGetter.categories

      },
    },

    computed: {

      customer() {
        return this.$store.getters.customer;
      },

      blobUrl() {
          if (!this.serviceCenterAddress.certificate) return null;
          try {
              const base64String = this.serviceCenterAddress.certificate.split(',')[1];
              const byteCharacters = atob(base64String);
              const byteArrays = [];
              for (let i = 0; i < byteCharacters.length; i += 512) {
              const slice = byteCharacters.slice(i, i + 512);
              const byteNumbers = new Array(slice.length);
              for (let j = 0; j < slice.length; j++) {
                  byteNumbers[j] = slice.charCodeAt(j);
              }
              byteArrays.push(new Uint8Array(byteNumbers));
              }

              const blob = new Blob(byteArrays, { type: "application/pdf" });
              return URL.createObjectURL(blob);
          } catch (error) {
              console.error("Invalid base64 data:", error);
              return null;
          }
      }
  },
    setup(props, { emit }) {
      let serviceCenterAddress =
        (props.data_ != undefined ? reactive(props.data_) : reactive(store.getters.serviceCenterAddress));

      let autocomplete = null;
  
      const init = () => {
        var input = document.getElementById("locationTextField1");
        if(!autocomplete) 
        {
          autocomplete = new google.maps.places.Autocomplete(input)
          console.log(autocomplete)
          google.maps.event.addListener(autocomplete, "place_changed", function() {
            var place = autocomplete.getPlace();
            if (place.business_status) {
              serviceCenterAddress.name = place.name
            }
            if(place.international_phone_number){
              for(var i = 0; i < place.address_components.length; i++) {
                var addressObj = place.address_components[i];
                for(var j = 0; j < addressObj.types.length; j++) {
                  if (addressObj.types[j] === 'country') {
                    serviceCenterAddress.phone_dial = phoneCodes.find(phoneCode=>phoneCode.name==addressObj.long_name).dial_code
                    serviceCenterAddress.phone_number = serviceCenterAddress.phone_dial + place.formatted_phone_number
                    break
                  }
                }
              } 
            }
            var details = GooglePlacesHelper.extract(place.address_components);
            serviceCenterAddress.street_name = (details.route||"").trim();
            serviceCenterAddress.country = (details.country||"").trim();
            serviceCenterAddress.zip = (details.zip||"").trim();
            serviceCenterAddress.state = (details.state||"").trim();
            serviceCenterAddress.city = (details.city||"").trim();
            serviceCenterAddress.address = (place.formatted_address||"").trim()
          });
  
          input.addEventListener('blur', function (){
            setTimeout(function (){
    
              var service = new google.maps.places.AutocompleteService();
              service.getPlacePredictions({ input: input.value }, predictionsCallback);
              function predictionsCallback(predictions, status) {
                if (status != google.maps.places.PlacesServiceStatus.OK) return;
                
                let place_id = predictions[0].place_id
                const geocoder = new google.maps.Geocoder();
                geocoder
                .geocode({ placeId: place_id })
                .then(({ results }) => {
                  if (results[0]) {
                    var details = GooglePlacesHelper.extract(results[0].address_components);
                    serviceCenterAddress.street_name = (details.route||"").trim();
                    serviceCenterAddress.country = (details.country||"").trim();
                    serviceCenterAddress.zip = (details.zip||"").trim();
                    serviceCenterAddress.state = (details.state||"").trim();
                    serviceCenterAddress.city = (details.city||"").trim();
                    serviceCenterAddress.address = (results[0].formatted_address||"").trim()
                  } else {
                    window.alert("No results found");
                  }
                })
                .catch((e) => window.alert("Geocoder failed due to: " + e));
  
                }
                        
            }, 500);
            
          })
        }
      };
      const submitShippingValidate = () => {
        serviceCenterAddressScema
          .validate(serviceCenterAddress, { abortEarly: false })
          .then()
          .catch((e) => {
            for (let i = 0; i < e.errors.length; i++) {
              store.dispatch(
                SHOW_TOAST_MESSAGE,
                GeneralHelper.buildMessage(3, e.errors[i])
              );
            }
          });
      };
      const serviceCenterAddressScema = Yup.object().shape({
        email: Yup.string()
        .required()
        .email("Invalid email format")
        .label("Email"),
        phone_dial: Yup.string()
          .required()
          .label("Phone dial"),
        phone_number: Yup.string()
          .required()
          .label("Phone number"),
        address: Yup.string()
          .required()
          .label("Address"),
        city: Yup.string()
          .required()
          .label("City"),
        country: Yup.string()
          .required()
          .label("Country"),
        street_name: Yup.string()
          .required()
          .label("Street"),
      });
  
      const submitserviceCenterAddress = () => {
        serviceCenterAddressScema.isValid(serviceCenterAddress).then(function(valid) {
          if (!props.showSubmit) emit("validated", valid);
        });
        if (props.showSubmit) {
          
          if (serviceCenterAddress.id)
            store
              .dispatch(EDIT_SERVICE_CENTER, serviceCenterAddress)
              .then()
              .catch((e) => {
                if (e.response && e.response.data) {
                  store.dispatch(
                    SHOW_TOAST_MESSAGE,
                    GeneralHelper.buildMessage(3, e.response.data.message)
                  );
                }
              });
          else
            store
              .dispatch(CREATE_SERVICE_CENTER, serviceCenterAddress)
              .then(() => {})
              .catch((e) => {
                if (e.response && e.response.data) {
                  store.dispatch(
                    SHOW_TOAST_MESSAGE,
                    GeneralHelper.buildMessage(3, e.response.data.message)
                  );
                }
              });
        }
      };
  
      return {
        submitShippingValidate,
        serviceCenterAddressScema,
        submitserviceCenterAddress,
        serviceCenterAddress,
        init,
      };
    },
  
    props: {
      showSubmit: {
        Type: Boolean,
        default: true,
      },
      data_: Object,
      disabled:{
        Type: Boolean,
        default: false,
      },
    },
  };
  </script>
  
  <style lang="scss">
  @import '../../style/profile.scss';
  </style>
  